import { Control, useWatch } from 'react-hook-form';
import { StatusBadge } from '../../../../components/Badges/StatusBadge';
import { shouldVerifyBusinessNumber } from '../../../../utils/helpers/common';
import { WORKSPACE_DETAILS_FORM_FIELDS } from '../../shared/fieldNames';
import { WorkspaceDetailsFormValues } from '../../shared/types';

interface AbnGstStatusFieldsProps {
  control: Control<WorkspaceDetailsFormValues>;
}

export const AbnGstStatusFields = ({ control }: AbnGstStatusFieldsProps) => {
  const abnStatus = useWatch({
    control,
    name: WORKSPACE_DETAILS_FORM_FIELDS.abnStatus,
  });
  const gstStatus = useWatch({
    control,
    name: WORKSPACE_DETAILS_FORM_FIELDS.gstStatus,
  });
  const businessNumberCountry = useWatch({
    control,
    name: WORKSPACE_DETAILS_FORM_FIELDS.businessNumberCountry,
  });
  const entityName = useWatch({
    control,
    name: WORKSPACE_DETAILS_FORM_FIELDS.entityName,
  });
  const businessNumber = useWatch({
    control,
    name: WORKSPACE_DETAILS_FORM_FIELDS.businessNumber,
  });

  const showAbnStatus = Boolean(abnStatus) && Boolean(businessNumber);
  const showGstStatus = Boolean(gstStatus) && Boolean(businessNumber);

  if (
    !shouldVerifyBusinessNumber(businessNumberCountry) ||
    !entityName ||
    (!showAbnStatus && !showGstStatus)
  ) {
    return null;
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {showAbnStatus && abnStatus && (
        <div className="space-y-3">
          <p className="text-sm font-medium [fieldset:disabled_&]:opacity-50">
            ABN Status
          </p>

          {/*
            The badge dims inside the locked fieldset on its own — the app's
            `Badge` override carries the rule. Only the plain status line above
            needs it here.
          */}
          <StatusBadge type={abnStatus} />
        </div>
      )}

      {showGstStatus && gstStatus && (
        <div className="space-y-3">
          <p className="text-sm font-medium [fieldset:disabled_&]:opacity-50">
            GST Status
          </p>

          <StatusBadge type={gstStatus} />
        </div>
      )}
    </div>
  );
};
